import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentMusic: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0H4v9.035A3.5 3.5 0 1 0 7 12.5V5h6v4.035a3.5 3.5 0 1 0 3 3.465z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentMusic
